import { ObjectSchema } from 'yup';
import Yup from '../../../../../services/common/validation';
import { DriverDetailsFormModel_OB_FP } from './formModel';

export const getValidationSchema = (): ObjectSchema<Partial<DriverDetailsFormModel_OB_FP>> => {
  /* TODO: Replace below placeholder when FP product is brought back */
  return Yup.object({
    firstName: Yup.string() as any,
    lastName: Yup.string() as any,
  });
};
